__turbopack_context__.v({
  "CmsQuoteCentered": "I7ux9q_CmsQuoteCentered",
  "custom": "I7ux9q_custom",
  "custom-2": "I7ux9q_custom-2",
  "double": "I7ux9q_double",
  "type-sidelines": "I7ux9q_type-sidelines",
  "type-sidelines-dotted": "I7ux9q_type-sidelines-dotted",
});
